import classcat from "classcat";
import React from "react";

import { Button, TextInput } from "@touchtech/web-baselayer-ui";

import { SelectScannerModal } from "../SelectScannerModal";
import css from "./NameDevice.module.css";
import useManageNameDevice from "./hooks/useManageNameDevice";

const NameDevice = () => {
  const {
    deviceName,
    isPending,
    showScannerSelectionModal,
    t,
    handleCloseScannerSelectionModal,
    handleChangeDeviceName,
    handleConfirm,
  } = useManageNameDevice();

  return (
    <div className={css.container}>
      <div className={css.inputContainer}>
        <TextInput
          sizing="xl"
          value={deviceName}
          onChange={handleChangeDeviceName}
          width="full"
          autoCapitalize="sentences"
        />
      </div>
      <div className={classcat(["text-label-base", css.guidanceText])}>
        {t(
          "Choose a distinctive name for easy recognition. E.g. Kiosk 1 Entrance, POS-Main, Shared Tablet 1 ..."
        )}
      </div>
      <div className={css.buttonContainer}>
        <Button
          variant="primary"
          sizing="xl"
          onClick={handleConfirm}
          state={isPending ? "pending" : undefined}
          className={css.confirmButton}
          disabled={isPending}
        >
          {t("Confirm & Finish registration")}
        </Button>
      </div>
      {showScannerSelectionModal && (
        <SelectScannerModal onClose={handleCloseScannerSelectionModal} />
      )}
    </div>
  );
};

export default NameDevice;
